import { useLang } from "hooks/useLang"
import f1Tickets from "./f1tickets.json"
import f1Tickets_ar from "./f1tickets_ar.json"
import Image from "next/image"
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/free-mode"
import SAR from "components/Sar/SAR"
// import SideActionCard from "../sideActionCard/sideActionCard"

const F1Ticket = ({
    img,
    title,
    start_price,
    onClick,
}: { img: string; title: string; start_price: string; onClick }) => {
    const { t, lang } = useLang()
    return (
        <div
            onClick={onClick}
            className={`relative gap-2 ${lang === "ar" ? "ml-4" : "mr-4"} flex w-[230px] h-full shadow-md rounded-[5px] cursor-pointer `}
        >
            <div className="absolute top-0 left-0 w-full h-full  rounded-[5px] overflow-hidden">
                <Image
                    src={
                        "https://passticketsstorage.blob.core.windows.net/images/f1-2025" +
                        img
                    }
                    alt={title}
                    fill
                    priority
                    sizes="280px"
                    style={{
                        objectFit: "cover",
                    }}
                    className="rounded-[5px]"
                />
            </div>

            {/* Black overlay */}
            <div className="absolute inset-0 bg-black opacity-70 z-10 rounded-[5px]" />

            <div className="w-[280px] h-full flex z-10 flex-col ">
                {/* Text */}
                <div className="w-full h-full flex items-start">
                    <div className="font-bold text-white text-[24px] w-auto h-auto p-[15px]">
                        {title.split(" ").map((word, index) => (
                            <span key={index} className="block">
                                {word}
                            </span>
                        ))}
                    </div>
                </div>

                <div className="flex items-end flex-1 justify-between w-full ">
                    <div className="flex flex-col p-[15px]">
                        <span className="text-white text-[16px]">
                            {t("start")}
                        </span>
                        <SAR
                            textSize={24}
                            width={20}
                            height={20}
                            price={start_price}
                        />
                        {/* <span className="font-bold text-white text-[24px]">
                            {start_price}
                        </span> */}
                    </div>
                    <div className="flex flex-end bg-[#FFC700]  rounded-tl-[5px] rounded-br-[5px] cursor-pointer w-[75px] h-[75px] items-center justify-center">
                        <span className="text-[#D9D9D9] text-[60px] font-bold">
                            +
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const RenderF1Ticket = ({ onShowSidebar, setSideBarComponent }: any) => {
    const { lang } = useLang()
    const data = lang === "ar" ? f1Tickets_ar : f1Tickets

    const { t } = useLang()
    return (
        <div className="flex flex-row h-[300px] ">
            {data.map((ticket) => (
                <F1Ticket
                    key={ticket.title}
                    onClick={() => {
                        onShowSidebar()
                        setSideBarComponent(() => (
                            <div className="flex-col flex gap-6">
                                <div className="flex flex-col">
                                    <span className="text-[28px] font-bold text-black">
                                        {ticket.title}
                                    </span>
                                    {/* <span className="text-[16px] font-light text-black">THE PINNACLE OF HOSPITALITY</span> */}
                                </div>
                                <div>
                                    <Image
                                        src={
                                            "https://passticketsstorage.blob.core.windows.net/images/f1-2025" +
                                            ticket.img
                                        }
                                        alt={ticket.title}
                                        // fill
                                        width={20}
                                        height={150}
                                        // priority
                                        sizes="280px"
                                        style={{
                                            width: "100%",
                                            height: 200,
                                            // aspectRatio: 16 / 9,
                                            objectFit: "cover",
                                        }}
                                        className="rounded-[5px] w-full h-[150px]"
                                    />
                                </div>

                                <div>
                                    <span className="font-bold text-[16px] text-black">
                                        {t("whatTicketAfford")}
                                    </span>
                                    {ticket.benifits?.map((item, i) => {
                                        return (
                                            <div
                                                className="flex flex-row gap-1 mt-6"
                                                key={i}
                                            >
                                                {/* <span className=" text-black font-bold text-left">{`${item?.title}:`}</span> */}
                                                <span
                                                    className={`text-black text-${lang === "ar" ? "right" : "left"}`}
                                                >
                                                    <strong>
                                                        {item.title}
                                                    </strong>
                                                    :{item?.description}
                                                </span>
                                            </div>
                                        )
                                    })}

                                    {/* <SideActionCard/> */}
                                </div>
                            </div>
                        ))
                    }}
                    {...ticket}
                />
            ))}
        </div>
    )
}

export default RenderF1Ticket
